import React, {type FC, type ReactNode} from 'react';
import {Button, Modal} from 'semantic-ui-react';

type FullscreenModalProps = {
  open: boolean;
  onClose: () => void;
  // Shown in a fixed-width column beside the content, such as a panel's config.
  sidebar?: ReactNode;
  children?: ReactNode;
};

export const FullscreenModal: FC<FullscreenModalProps> = ({
  open,
  onClose,
  sidebar,
  children,
}) => (
  <Modal open={open} size="fullscreen" onClose={onClose}>
    <Modal.Content
      style={{
        // oxlint-disable-next-line wandb/no-calc-100vh-pixel-math
        height: 'calc(90vh - 73px)',
        overflow: 'auto',
        display: 'flex',
      }}>
      <div
        style={{
          flex: '1 1 auto',
          marginRight: '30px',
        }}>
        {children}
      </div>
      {sidebar != null && (
        <div
          style={{
            flex: '0 0 300px',
          }}>
          {sidebar}
        </div>
      )}
    </Modal.Content>
    <Modal.Actions>
      <Button data-test="panel-fullscreen-modal-close-button" onClick={onClose}>
        Close
      </Button>
    </Modal.Actions>
  </Modal>
);
